import moment from 'moment';
import 'moment/min/locales.js';

/**
 * Transaction dates are API calendar dates, not instants. The generated client
 * materializes a value such as 2026-09-30 as a Date at UTC midnight, so using
 * local Date accessors can incorrectly display September 29 in western zones.
 */
export const getTransactionDateKey = (date?: Date): string =>
  date ? moment.utc(date).format('YYYY-MM-DD') : '';

// French LL supplies day-month-year ordering without English ordinal suffixes.
// Preserve the existing English presentation while sharing UTC calendar dates.
export const formatTransactionDate = (date: Date, locale: string): string =>
  moment.utc(date).locale(locale.toLowerCase()).format(/^fr(?:-|$)/i.test(locale) ? 'dddd LL' : 'dddd, MMMM Do YYYY');
